/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Oauth_Return_To_ArchonInputs */



/**
* | output |
* | --- |
* | "Return to Archon" |
*
* @param {Oauth_Return_To_ArchonInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const oauth_return_to_archon = /** @type {((inputs?: Oauth_Return_To_ArchonInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Oauth_Return_To_ArchonInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retour à Archon")
	if (locale === "es") return /** @type {LocalizedString} */ ("Volver a Archon")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Retornar para Archon")
	if (locale === "it") return /** @type {LocalizedString} */ ("Torna ad Archon")
	return /** @type {LocalizedString} */ ("Return to Archon")
});